// extracted by mini-css-extract-plugin
module.exports = {"root":"WholePageMessage_root__Yt1v9","fullHeight":"WholePageMessage_fullHeight__TED1o","content":"WholePageMessage_content__EaK7_","button":"WholePageMessage_button__x2yjk"};